import enumeration from "./enumeration";

const GuestStatus = {
  CHECKED_IN: "CHECK_IN",
  CHECKED_OUT: "CHECK_OUT",
};

const GuestStatus_V1 = {
  CHECKED_IN: "CHECKED_IN",
  CHECKED_OUT: "CHECKED_OUT",
};

export default enumeration(GuestStatus);
export const GuestStatusV1 = enumeration(GuestStatus_V1);
